import React, { useState, useMemo, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { demoContext } from "../../../shared/store/contexts";

import * as Icon from "react-feather";
import { H1, H2, H3, H4, P } from "../../atoms/Texts";
import { PrimaryButton, OutlineButton } from "../../atoms/Buttons";
import RoutesTabs from "../InitiativeTab";
import DeleteModal from "../../organisms/DeleteModal";
import EditInitiativeModal from "../EditInitiativeModal";
import InitiativeSuccessModal from "../InitiativeSuccessModal";
import InitiativeSendInvite from "../InitiativeSendInvite";
import { InitiativeOptCard } from "../../atoms/Cards";

import {
  getInitials,
  toastError,
  toastSuccess,
  toastWarning,
} from "../../../shared/helpers";

const ViewInitiativesLayoutStyle = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ViewInitiativeLayout = (props) => {
  const { initiative } = useContext(demoContext);

  const history = useNavigate();
  const { id, initiativeId } = useParams();

  const [showArrow, setShowArrow] = useState("right");

  const [openSuccess, setOpenSuccess] = useState(false);

  const [showEditInitiativeeModal, setShowEditInitiativeModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showDeleteInitiativeeModal, setShowDeleteInitiativeModal] = useState(false);

  const toggleDeleteInitiativeeModal = () =>
    setShowDeleteInitiativeModal(!showDeleteInitiativeeModal);

  const toggleEditInitiativeeModal = () =>
    setShowEditInitiativeModal(!showEditInitiativeeModal);

  const toggleInviteModal = () => setShowInviteModal(!showInviteModal);

  const carouselRef = useRef();

  const carouselScroll = (toRight) => {
    const scrollLength = 300;

    carouselRef.current.scrollBy({
      left: scrollLength * (toRight ? 1 : -1),
      behavior: "smooth",
    });

    setShowArrow(toRight ? "left" : "right");
  };

  return (
    <ViewInitiativesLayoutStyle>
      <div className="pb-10 flex-grow flex flex-col mt-6">
        <div>
          <section
            style={{
              background: "#f8f6fe",
            }}
            className="pt-16 pb-4 px-4 lg:px-6 xl:px-10 "
          >
            <div className="flex  flex-col lg:flex-row gap-y-4 justify-between lg:items-center">
              <div className="flex-1">
                <H1 fontSize="26px" color="#22202D" className="">
                  {initiative?.name}
                </H1>

                <div
                  style={{
                    width: "fit-content",
                  }}
                  className="mt-2 border border-gray-400 rounded-full px-2 py-1"
                >
                  <P fontSize="12px" color="#828282">
                    {initiative.service?.name}
                  </P>
                </div>
              </div>

              {id === initiative?.organizationId && (
                <div className="flex gap-4">
                  <OutlineButton
                    onClick={toggleEditInitiativeeModal}
                    bg="transparent"
                    color="#4F4F4F"
                    border="1px solid #4F4F4F"
                  >
                    Edit Initiative
                  </OutlineButton>

                  <OutlineButton
                    onClick={toggleDeleteInitiativeeModal}
                    bg="transparent"
                    color="#DF0303"
                    border="1px solid #DF0303"
                  >
                    Delete Initiative
                  </OutlineButton>
                </div>
              )}
            </div>

            <Link to={`/dashboard/organization/${id}/initiatives`}>
              <div
                className="mt-10 flex items-center cursor-pointer"
                style={{
                  width: "fit-content",
                }}
              >
                <Icon.ChevronLeft size={14} color="#7D7B96" className="mr-2" />
                <P color="#1E202A" fontSize="14px" smallSize="14px">
                  Back to Initiatives
                </P>
              </div>
            </Link>
          </section>

          <section className=" px-4 lg:px-10 mt-8 mb-12 flex justify-between items-center overflow-x-hidden">
            {initiative?.images?.length > 0 ? (
              <div className="no-scrollbar w-2/3 flex items-center gap-x-4">
                <div
                  ref={carouselRef}
                  className="flex-1 flex gap-x-2 overflow-x-auto "
                >
                  {initiative?.images?.map((item, index) => (
                    <div key={item.id}>
                      <div className="relative h-32 w-32">
                        <img
                          className="object-cover h-full w-full"
                          src={item}
                          alt={`initiative + ${index}`}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div>
                  {initiative?.images?.length < 4 ? (
                    ""
                  ) : showArrow === "left" ? (
                    <Icon.ArrowLeftCircle
                      onClick={() => carouselScroll(false)}
                      size={24}
                      color="#7D7B96"
                      className=" cursor-pointer"
                    />
                  ) : (
                    <Icon.ArrowRightCircle
                      onClick={() => carouselScroll(true)}
                      size={24}
                      color="#7D7B96"
                      className=" cursor-pointer"
                    />
                  )}
                </div>
              </div>
            ) : (
              <div></div>
            )}

            {id === initiative?.organizationId ? (
              <div>
                <PrimaryButton onClick={toggleInviteModal}>
                  Send Invite
                </PrimaryButton>
              </div>
            ) : (
              <div>
                <PrimaryButton>Opt-in</PrimaryButton>
              </div>
            )}
          </section>

          {/* description */}
          <section className=" px-4 lg:px-10 ">
            <H2 className="mb-6" fontFamily="medium" fontSize="18px" color="#000000">
              Description
            </H2>

            <div className="flex justify-between gap-4 lg:gap-8">
              <section className="flex-1 bg-white p-8">
                <P
                  style={{
                    whiteSpace: "pre-line",
                  }}
                  className="mt-2 text-sm"
                >
                  {" "}
                  {initiative?.description}
                </P>
              </section>

              <section
                style={{
                  height: "fit-content",
                  maxHeight: "390px",
                  width: "220px",
                }}
                className="py-16 px-8 bg-white flex items-center justify-center text-center"
              >
                {initiative?.organizations?.length > 0 ? (
                  <div className="text-center">
                    <div className="flex justify-center -space-x-4 mb-3">
                      {initiative?.organizations?.slice(0, 3)?.map((item) => (
                        <div
                          key={item.id}
                          className="w-8 h-8 relative p-5 text-sm uppercase bg-gray-200 border-2 border-white rounded-full flex items-center justify-center text-center text-black "
                        >
                          {item?.logoUrl ? (
                            <img
                              className="h-full w-full object-cover "
                              src={item?.logoUrl}
                              alt={item.name}
                            />
                          ) : (
                            getInitials(item?.name)
                          )}
                        </div>
                      ))}
                    </div>

                    <P color="#5F5D77" fontSize="14px" smallSize="12px">
                      {initiative?.organizations?.length}{" "}
                      {initiative?.organizations?.length > 1
                        ? "Organizations are members"
                        : "Organization is a member"}{" "}
                      of the initiative
                    </P>

                    <div className="mt-3">
                      <Link
                        to={`/dashboard/organization/${id}/initiatives/${initiativeId}/view-organizations`}
                      >
                        <PrimaryButton
                          fontFamily="medium"
                          bg="#DCD6FE"
                          color="#442ED0"
                          p="9px 15px"
                          className="flex items-center justify-center gap-x-2 mx-auto"
                        >
                          <span>View All</span>

                          <Icon.ChevronRight size={14} color="#442ED0" />
                        </PrimaryButton>
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div>
                    <P color="#5F5D77" fontSize="14px" smallSize="12px">
                      No Organization has opt-in for this initiative
                    </P>
                  </div>
                )}
              </section>
            </div>
          </section>

          <div className="px-4 lg:px-10 mt-10">
            <div className="bg-white py-10 mb-10">
              <H4
                fontFamily="medium"
                fontSize="14"
                color="#22202D"
                className="text-center"
              >
                You do not have Opt-in requests yet.
              </H4>
            </div>

            {/* referrals */}
            <section>
              <H3
                className="mb-6"
                fontFamily="medium"
                fontSize="18px"
                color="#000000"
              >
                Referrals
              </H3>
              <RoutesTabs
                data={[
                  {
                    id: 1,
                    name: "Pending",
                    href: `/dashboard/organization/${id}/initiatives/${initiativeId}/pending-referrals`,
                  },
                  {
                    id: 2,
                    name: "Approved",
                    href: `/dashboard/organization/${id}/initiatives/${initiativeId}/approved-referrals`,
                  },
                  {
                    id: 3,
                    name: "Rejected",
                    href: `/dashboard/organization/${id}/initiatives/${initiativeId}/rejected-referrals`,
                  },
                ]}
              />

              <div className="py-6 border-t border-gray-300">{props.children}</div>
            </section>
          </div>
        </div>

        {openSuccess && (
          <InitiativeSuccessModal
            closeModal={() =>
              (window.location.pathname = `/dashboard/organization/${id}/initiatives`)
            }
            message1="We have sent your opt-in request to the South Dallas Employment Project. You will be notified when your request is accepted"
          />
        )}

        {showEditInitiativeeModal && (
          <EditInitiativeModal
            initiative={{
              name: initiative?.name,
              address: initiative?.address,
              id: initiative?.initiativeId,
              service: initiative?.service,
              description: initiative?.description,
              images: initiative?.images,
            }}
            closeModal={toggleEditInitiativeeModal}
          />
        )}

        {showDeleteInitiativeeModal && (
          <DeleteModal
            header="Delete Initiative"
            closeModal={toggleDeleteInitiativeeModal}
            cta="Delete"
            action={() => toastWarning("Can not perform this action on Demo mode")}
            warning="Deleting this initiative is irreversible, are you certain of this action?"
          />
        )}

        {showInviteModal && (
          <InitiativeSendInvite
            orgId={id}
            initiativeId={initiativeId}
            closeModal={toggleInviteModal}
          />
        )}
      </div>
    </ViewInitiativesLayoutStyle>
  );
};

export default ViewInitiativeLayout;
